// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3GI_-","fileBtn":"File_fileBtn__3l6wz","closeBtn":"File_closeBtn__37fDE","fileSelected":"File_fileSelected__1szvE","disabled":"File_disabled__2by3s"};